/* eslint-disable react/no-array-index-key */
// eslint-disable-next-line simple-import-sort/imports
import { FC } from 'react';
import clsx from 'clsx';
import { useStyles } from './style';
import Action from './the_action';

interface ITableAction {
  data: any[];
  header: any[];
  bgColor: string;
  actionBtn: (data: any, type: string) => (e: any) => void;
  variant?: 'default' | 'hierarchy';
}

const TableAction: FC<ITableAction> = ({
  data,
  header,
  bgColor,
  actionBtn,
  variant = 'default',
}) => {
  const classes = useStyles();
  const isHierarchy = variant === 'hierarchy';

  return (
    <div className={classes.root}>
      {(header || []).map((item: any) => {
        return (
          <div key={item.key} className={classes.coulomContent} style={{ width: item?.width }}>
            <div className={classes.header} style={{ backgroundColor: bgColor }}>
              {item.label}
            </div>

            {(data || []).map((x: any, index: number) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div
                  className={clsx(classes.content, {
                    [classes.consultantContent]: isHierarchy,
                  })}
                  key={index}>
                  <Action
                    index={index}
                    rowOne={x}
                    listAction={item?.option?.listAction}
                    actionBtn={actionBtn}
                  />
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default TableAction;
